import React from 'react';
import classNames from 'classnames/index';
import PropTypes from "prop-types";

class ItemViewImages extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeImage: getActiveImage(props.item)
    };

    this.setActiveImage = this.setActiveImage.bind(this);
    this.getImageThumbnails = this.getImageThumbnails.bind(this);
    this.showNextImage = this.showNextImage.bind(this);
    this.showPreviousImage = this.showPreviousImage.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item) {
      this.setState({
        activeImage: getActiveImage(nextProps.item)
      });
    }
  }

  setActiveImage(image) {
    this.setState({
      activeImage: image
    });
  }

  getImageThumbnails() {
    return this.props.item.images.map(function (image, index) {
      let imageClasses = classNames({
        "m-active": this.state.activeImage.id === image.id,
        "item-view__images-thumbs-thumb": true
      });

      return (
        <div key={index} className={imageClasses} onClick={() => this.setActiveImage(image)}>
          <img src={image.thumbnailImage}/>
        </div>
      );
    }.bind(this));
  }

  showNextImage() {
    let newActiveImage;
    const activeIndex = this.props.item.images.findIndex(image => image.id === this.state.activeImage.id);

    if (this.props.item.images.length > activeIndex + 1) {
      newActiveImage = this.props.item.images[activeIndex + 1];
    } else {
      newActiveImage = this.props.item.images[0];
    }

    this.setState({
      activeImage: newActiveImage
    });
  }

  showPreviousImage() {
    let newActiveImage;
    const activeIndex = this.props.item.images.findIndex(image => image.id === this.state.activeImage.id);

    if (activeIndex === 0) {
      newActiveImage = this.props.item.images[this.props.item.images.length - 1];
    } else {
      newActiveImage = this.props.item.images[activeIndex - 1];
    }

    this.setState({
      activeImage: newActiveImage
    });
  }

  render() {
    const imageThumbnails = this.getImageThumbnails();
    const leftArrow = this.props.item.images.length > 1? (
      <div className="item-view__images-left" onClick={this.showPreviousImage}>
        <i className="fa fa-chevron-left"></i>
      </div>
    ): '';

    const rightArrow = this.props.item.images.length > 1? (
      <div className="item-view__images-right" onClick={this.showNextImage}>
        <i className="fa fa-chevron-right"></i>
      </div>
    ): '';

    const activeImage = this.state.activeImage? (
      <img src={this.state.activeImage.mainImage} alt="Image of the item"/>
    ): '';

    return (
      <div className="item-view__images">
        <div className="item-view__images-image">
          {activeImage}
        </div>
        <div className="item-view__images-thumbs">
          {imageThumbnails}
        </div>
        {rightArrow}
        {leftArrow}
      </div>
    );
  }
}

ItemViewImages.propTypes = {
  item: PropTypes.object.isRequired,
};

ItemViewImages.defaultProps = {
  item: {},
};

function getActiveImage(item) {
  return item.images.length > 0 ? item.images[0] : null;
}

export default ItemViewImages;